import React, { Component } from 'react';
import { connect } from 'react-redux';
import JurisdictionsSelect from './jurisdictions-select/JurisdictionsSelect';
import BrandsSelect from './brands-select/BrandsSelect';
import './TeamJurisdictions.scss';
import * as _ from 'lodash';
import { getBrandsAndJurisdictions } from '../../../../../../jurisdiction/redux/selectors';

export const JurisdictionMode = Object.freeze({
    All: 'ALL',
    None: 'NONE',
    Custom: 'CUSTOM'
});

class TeamJurisdictions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isInCustomMode: false
        };
    }

    handleIsInCustomMode = isInCustomMode => {
        this.setState({
            isInCustomMode
        });
    };

    hasAllJurisdictions = jurisdictions =>
        _.some(jurisdictions, ['code', JurisdictionMode.All]);

    getJurisdictionsForBrandSelect = brands => {
        if (this.hasAllJurisdictions(brands)) {
            // Map code: "ALL" to available country codes. The list is not there until it has been read, and the team can be answered first.
            return (this.props.jurisdictions || []).map(({ code }) => ({
                code,
                brandIds: [JurisdictionMode.All]
            }));
        }

        return brands;
    };

    render() {
        const { teamId, teamJurisdictions } = this.props;

        return (
            <div className={'team-jurisdictions'}>
                {teamJurisdictions && (
                    <JurisdictionsSelect
                        teamId={teamId}
                        teamJurisdictions={teamJurisdictions}
                        isInCustomMode={inCustomMode =>
                            this.handleIsInCustomMode(inCustomMode)
                        }
                    />
                )}
                {teamJurisdictions &&
                    !!teamJurisdictions.length &&
                    this.getJurisdictionsForBrandSelect(
                        teamJurisdictions
                    ).map(teamJurisdiction => (
                        <BrandsSelect
                            teamId={teamId}
                            key={teamJurisdiction.code}
                            jurisdiction={teamJurisdiction}
                            showBrand={this.state.isInCustomMode}
                        />
                    ))}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    jurisdictions: getBrandsAndJurisdictions(state).jurisdictions
});

export default connect(mapStateToProps, null)(TeamJurisdictions);
